import { render, staticRenderFns } from "./RonovatecOverEachOtherButton.vue?vue&type=template&id=61d5bc4c&scoped=true&"
import script from "./RonovatecOverEachOtherButton.vue?vue&type=script&lang=ts&"
export * from "./RonovatecOverEachOtherButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5bc4c",
  null
  
)

export default component.exports